const participantName = ({ firstName, lastName, preferredName }) =>
  preferredName || `${firstName || ''} ${lastName || ''}`.trim();

const speakerFromParticipant = participant => ({
  id: String(participant.id),
  name: participantName({
    firstName: participant.first_name,
    lastName: participant.last_name,
    preferredName:
      participant.preference?.preferred_name || participant.preferred_name,
  }),
  avatarUrl: participant.avatar?.url,
});

// Phone Call (pending), Phone Unknown (unknown), Phone + first digit (resolved).
const phoneAvatarFallback = phoneCall => {
  if (phoneCall.status === 'pending') return 'PC';
  if (phoneCall.status === 'unknown') return 'PU';
  return `P${phoneCall.from_number_last4?.[0] || ''}`;
};

export const resolveCaptionSpeaker = ({
  appointment,
  event,
  voiceCalls,
  phoneSpeakerName,
}) => {
  if (event.participantId) {
    const participantId = String(event.participantId);
    const appointmentUser = (appointment.users || []).find(
      ({ user }) => String(user?.id) === participantId,
    );
    if (appointmentUser) {
      return {
        ...speakerFromParticipant(appointmentUser.user),
        name: participantName({
          firstName: appointmentUser.user.first_name,
          lastName: appointmentUser.user.last_name,
          preferredName: appointmentUser.preference?.preferred_name,
        }),
      };
    }

    const couplesParticipant = appointment.couples_appointment_detail
      ? Object.values(appointment.couples_appointment_detail).find(
          participant => String(participant?.id) === participantId,
        )
      : undefined;
    if (couplesParticipant) return speakerFromParticipant(couplesParticipant);

    if (String(appointment.client?.id) === participantId) {
      return speakerFromParticipant(appointment.client);
    }

    if (String(appointment.counsellor?.id) === participantId) {
      return speakerFromParticipant(appointment.counsellor);
    }
  }

  const phoneCall = (voiceCalls || []).find(
    call => call.video_session_connection_id === event.connectionId,
  );
  if (!phoneCall) return undefined;

  return {
    id: `phone:${phoneCall.video_session_connection_id}`,
    name: phoneSpeakerName(phoneCall),
    avatarFallback: phoneAvatarFallback(phoneCall),
  };
};
